<template>
	<div class="lock-device-container">
		<!-- 面包屑导航区域 -->		<!-- 卡片视图区域 -->
		<el-card class="box-card">
			<!-- 搜索与添加区域 gutter设置两列之间的间距 -->
			<div class="search-area">
				<el-form ref="lockDevicePageInfoReq" :model="lockDevicePageInfoReq" label-width="70px" inline
					size="small">
					<el-form-item label="运营商:" v-if="isAdmin">
						<el-select v-model="lockDevicePageInfoReq.distributorId" placeholder="请选择" clearable filterable
							style="width: 120px;">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="锁编号:">
						<el-input :clearable=true v-model="lockDevicePageInfoReq.qrNumber" placeholder="请输锁编号"
							style="width: 150px;" />
					</el-form-item>
					<el-form-item label="IMEI:">
						<el-input :clearable=true v-model="lockDevicePageInfoReq.imei" placeholder="请输IMEI"
							style="width: 150px;" />
					</el-form-item>
					<el-form-item label="定位方式:">
						<el-select v-model="lockDevicePageInfoReq.positionMode" placeholder="请选择" clearable
							style="width: 120px;">
							<el-option v-for="item in positionModeOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="车锁类型:">
						<el-select v-model="lockDevicePageInfoReq.bicycleType" placeholder="请选择" clearable
							style="width: 120px;" @change="handleBicycleTypeChange">
							<el-option v-for="item in bicycleTypeOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="车辆类型:">
						<el-select v-model="lockDevicePageInfoReq.deviceType" placeholder="请选择" clearable
							style="width: 140px;">
							<el-option v-for="item in deviceTypeOptions" :key="item.deviceTypeCode" :label="item.deviceTypeName"
								:value="item.deviceTypeCode">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="协议类型:" v-if="isAdmin">
						<el-select v-model="lockDevicePageInfoReq.protocolType" placeholder="请选择" clearable
							style="width: 140px;">
							<el-option v-for="item in protocolTypeOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否分配:" v-if="isAdmin">
						<el-select v-model="lockDevicePageInfoReq.allotStatus" placeholder="请选择" clearable
							style="width: 120px;">
							<el-option v-for="item in allotStatusOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="锁状态:">
						<el-select v-model="lockDevicePageInfoReq.lockStatus" placeholder="请选择" clearable
							style="width: 120px;">
							<el-option v-for="item in lockStatusOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="是否上架:">
						<el-select v-model="lockDevicePageInfoReq.isValid" placeholder="请选择" clearable
							style="width: 120px;">
							<el-option label="上架" :value="1"></el-option>
							<el-option label="下架" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="reGetlockDeviceList()">查询</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="primary" @click="initLockDevice()">+ 添加车锁信息</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="primary" @click="initLockDeviceAllocation()">车锁分配</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="danger" icon="el-icon-delete" @click="batchDelete"
							:disabled="multipleSelection.length === 0">批量删除</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="success" icon="el-icon-unlock" @click="batchUnlock"
							:disabled="multipleSelection.length === 0">批量开锁</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="warning" icon="el-icon-lock" @click="batchLock"
							:disabled="multipleSelection.length === 0">批量关锁</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="success" icon="el-icon-top" @click="batchOnline"
							:disabled="multipleSelection.length === 0">批量上架</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="warning" icon="el-icon-bottom" @click="batchOffline"
							:disabled="multipleSelection.length === 0">批量下架</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="primary" icon="el-icon-connection" @click="batchSwitchIp"
							:disabled="multipleSelection.length === 0">批量切换IP</el-button>
					</el-form-item>
					<el-form-item>
						<el-button type="success" icon="el-icon-location" @click="batchLocate"
							:disabled="multipleSelection.length === 0">批量定位</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="warning" icon="el-icon-refresh-left" @click="batchRevokeAllocation"
							:disabled="multipleSelection.length === 0">批量撤销分配</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="primary" icon="el-icon-edit" @click="batchModifyBicycleType"
							:disabled="multipleSelection.length === 0">批量修改锁类型</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="primary" icon="el-icon-edit" @click="batchModifyDeviceType"
							:disabled="multipleSelection.length === 0">批量修改车辆类型</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="primary" icon="el-icon-edit" @click="batchModifyProtocolType"
							:disabled="multipleSelection.length === 0">批量修改协议类型</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="success" icon="el-icon-moon" @click="batchSleep"
							:disabled="multipleSelection.length === 0">批量休眠</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="warning" icon="el-icon-microphone" @click="batchSetVoice"
							:disabled="multipleSelection.length === 0">批量设置语音播报</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="primary" icon="el-icon-chat-dot-round" @click="batchModifyCustomVoice"
							:disabled="multipleSelection.length === 0">批量修改自定义语音</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="primary" icon="el-icon-refresh" @click="batchUpgrade"
							:disabled="multipleSelection.length === 0">批量升级</el-button>
					</el-form-item>
					<el-form-item v-if="isAdmin">
						<el-button type="primary" icon="el-icon-upload2"
							@click="handleImportLockDevices">批量导入车锁</el-button>
						<input type="file" ref="fileInput" style="display: none" accept=".xlsx, .xls"
							@change="handleFileChange">
					</el-form-item>
				</el-form>
			</div>
			<!-- 表格和分页区域 -->
			<div class="table-container">
				<!-- 锁列表区域 -->
				<el-table :data="lockDeviceList" border stripe :header-cell-style="{ textAlign: 'center' }"
					:cell-style="{ textAlign: 'center' }" @selection-change="handleSelectionChange" @sort-change="handleSortChange">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column type="index"></el-table-column>
					<el-table-column label="IMEI" prop="imei" width="130px"></el-table-column>
					<el-table-column label="锁编号" prop="qrNumber" width="130px" sortable="custom"></el-table-column>
					<el-table-column label="锁类型" prop="bicycleType" width="80px">
						<template slot-scope="scope">
							<el-tag 
								v-if="scope.row.bicycleType == 1" 
								type="success" 
								size="small"
								style="background-color: #f0f9eb; color: #67c23a; border: 1px solid #e1f3d8;"
							>
								自行车
							</el-tag>
							<el-tag 
								v-else-if="scope.row.bicycleType == 2" 
								type="warning" 
								size="small"
								style="background-color: #fdf6ec; color: #e6a23c; border: 1px solid #faecd8;"
							>
								电动车
							</el-tag>
							<el-tag 
								v-else-if="scope.row.bicycleType == 3" 
								type="primary" 
								size="small"
								style="background-color: #ecf5ff; color: #409eff; border: 1px solid #d9ecff;"
							>
								涨闸锁
							</el-tag>
							<el-tag 
								v-else 
								type="info" 
								size="small"
								style="background-color: #f4f4f5; color: #909399; border: 1px solid #e9e9eb;"
							>
								未知
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="车辆类型" width="100px" prop="deviceType">
						<template slot-scope="scope">
							{{ getDeviceTypeName(scope.row.deviceType) || '未设置' }}
						</template>
					</el-table-column>
					<el-table-column label="运营商" prop="distributorName" width="120px" show-overflow-tooltip></el-table-column>
					<el-table-column v-if="isAdmin" label="协议类型" prop="protocolType" width="120px">
						<template slot-scope="scope">
							<el-tag 
								v-if="scope.row.protocolType == 1" 
								type="primary" 
								size="small"
								style="background-color: #ecf5ff; color: #409eff; border: 1px solid #d9ecff;"
							>
								友信智联协议
							</el-tag>
							<el-tag
								v-else-if="scope.row.protocolType == 2"
								type="success"
								size="small"
								style="background-color: #f0f9eb; color: #67c23a; border: 1px solid #e1f3d8;"
							>
								义卫士4G协议
							</el-tag>
							<el-tag
								v-else-if="scope.row.protocolType == 3"
								type="warning"
								size="small"
								style="background-color: #fdf6ec; color: #e6a23c; border: 1px solid #faecd8;"
							>
								义卫士蓝牙协议
							</el-tag>
							<el-tag
								v-else
								type="info"
								size="small"
								style="background-color: #f4f4f5; color: #909399; border: 1px solid #e9e9eb;"
							>
								未设置
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column label="主电量" prop="mainElectricity"></el-table-column>
					<el-table-column label="电池电压" prop="batteryVoltage">
						<template slot-scope="scope">
							{{ scope.row.batteryVoltage != null ? scope.row.batteryVoltage + 'V' : '-' }}
						</template>
					</el-table-column>
					<el-table-column label="经度" prop="longitude" show-overflow-tooltip width="80px"></el-table-column>
					<el-table-column label="纬度" prop="latitude" show-overflow-tooltip width="80px"></el-table-column>
					<el-table-column label="定位方式" prop="positionMode">
						<template slot-scope="scope">
							{{ scope.row.positionMode == 1 ? '基站定位' : (scope.row.positionMode == 2 ? 'GPS定位' :
								(scope.row.positionMode == 3 ? '手机定位' : '未知')) }}
						</template>
					</el-table-column>
					<el-table-column label="设备状态" prop="lockStatus">
						<template slot-scope="scope">
							{{ scope.row.lockStatus == 1 ? '开锁' : (scope.row.lockStatus == 2 ? '关锁' : '未知') }}
						</template>
					</el-table-column>
					<el-table-column label="版本号" prop="contractVersion" show-overflow-tooltip width="100px"></el-table-column>
					<el-table-column label="是否在线" prop="isOnline">
						<template slot-scope="scope">
							<span :style="{ color: scope.row.isOnline ? '#67C23A' : '#F56C6C' }">
								{{ scope.row.isOnline ? '在线' : '离线' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="是否上架" prop="isValid" width="120px">
						<template slot-scope="scope">
							<el-switch
								v-model="scope.row.isValid"
								:active-value="1"
								:inactive-value="0"
								active-color="#67C23A"
								inactive-color="#909399"
								@change="handleValidChange(scope.row)"
							>
							</el-switch>
							<span style="margin-left: 8px; font-size: 12px;" :style="{ color: scope.row.isValid === 1 ? '#67C23A' : '#909399' }">
								{{ scope.row.isValid === 1 ? '上架中' : '下架中' }}
							</span>
						</template>
					</el-table-column>
					<el-table-column label="最后在线时间" prop="lastOnlineTime" width="155px"></el-table-column>
					<el-table-column label="最后定位时间" prop="gsmUpdateTime" width="155px"></el-table-column>
					<el-table-column label="自定义语音" prop="enableCustomVoice" width="100px" v-if="isAdmin">
						<template slot-scope="scope">
							<el-tag v-if="scope.row.enableCustomVoice === 1" type="success" size="small">已开启</el-tag>
							<el-tag v-else type="info" size="small">未开启</el-tag>
						</template>
					</el-table-column>
					<el-table-column v-if="isAdmin" label="关锁语音" prop="lockVoiceContent" width="155px" show-overflow-tooltip></el-table-column>
					<el-table-column v-if="isAdmin" label="围栏内还车语音" prop="fenceReturnVoiceContent" width="155px" show-overflow-tooltip></el-table-column>
					<el-table-column fixed="right" header-align="center" align="center" :width="isAdmin ? 350 : 210" label="操作">
						<template slot-scope="scope">
							<el-button v-if="isAdmin" size="mini" type="primary" icon="el-icon-edit"
									@click="updateLockDeviceInit(scope.row.id)">编辑</el-button>
							<el-button v-if="isAdmin" size="mini" type="danger" icon="el-icon-delete"
								@click="deleteLockDevice(scope.row.id, scope.row.qrNumber)">删除</el-button>
							<el-button size="mini" type="warning" icon="el-icon-position"
								@click="showTrackDialog(scope.row)">轨迹</el-button>
							
							<el-dropdown @command="handleCommand" trigger="click">
								<el-button size="mini" type="primary">
									指令下发<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown">
									<el-dropdown-item
										:command="{ action: 'unlock', id: scope.row.id, imei: scope.row.imei }">开锁指令</el-dropdown-item>
									<el-dropdown-item
										:command="{ action: 'lock', id: scope.row.id, imei: scope.row.imei }">关锁指令</el-dropdown-item>
									<el-dropdown-item v-if="isAdmin"
										:command="{ action: 'switchIp', id: scope.row.id, imei: scope.row.imei }">切换IP指令</el-dropdown-item>
									<el-dropdown-item
									:command="{ action: 'locate', id: scope.row.id, imei: scope.row.imei }">定位指令</el-dropdown-item>
								<el-dropdown-item
									:command="{ action: 'findVehicle', id: scope.row.id, imei: scope.row.imei }">找车指令</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
						</template>
					</el-table-column>
				</el-table>
				<!-- 分页区域 -->
				<div class="pagination-container">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page="lockDevicePageInfoReq.page" :page-sizes="[8, 15, 25, 50, 100, 200,500,1000]"
						:page-size="lockDevicePageInfoReq.limit" layout="total, sizes, prev, pager, next, jumper"
						:total="total">
					</el-pagination>
				</div>
			</div>

			<!-- 车锁信息修改 -->
			<el-dialog title="车锁信息修改" :visible.sync="updateLockDeviceDialogVisible" width="800px">
				<el-form :model="lockDevicInfo" status-icon :rules="addLockDeviceRules" ref="lockDevicInfoUpdate"
					label-width="100px" class="demo-ruleForm" style="padding-right: 50px;">
					<el-col :span="12">
						<el-form-item label="锁编号:" prop="qrNumber">
							<el-input v-model.trim="lockDevicInfo.qrNumber"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="IMEI:" prop="imei">
							<el-input v-model.trim="lockDevicInfo.imei" type="text" size="small"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="Mac地址:" prop="mac">
							<el-input v-model.trim="lockDevicInfo.mac" type="text" size="small"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="UUID:" prop="uuid">
							<el-input v-model.trim="lockDevicInfo.uuid"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="Sim卡:" prop="sim">
							<el-input v-model.trim="lockDevicInfo.sim"></el-input>
						</el-form-item>
					</el-col>
					<!-- <el-col :span="12">
						<el-form-item label="sim卡商:" prop="operator">
							<el-select :clearable=true v-model="lockDevicInfo.operator" :filterable=true
								placeholder="请选择">
								<el-option v-for="item in operatorOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col> -->
					<el-col :span="12">
						<el-form-item label="经度:" prop="longitude">
							<el-input v-model.trim="lockDevicInfo.longitude"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="纬度:" prop="latitude">
							<el-input v-model.trim="lockDevicInfo.latitude"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="主电量:" prop="mainElectricity">
							<el-input v-model.trim="lockDevicInfo.mainElectricity"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="副电量:" prop="viceElectricity">
							<el-input v-model.trim="lockDevicInfo.viceElectricity"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="二维码链接:" prop="qrCode">
							<el-input v-model.trim="lockDevicInfo.qrCode"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="设备状态:" prop="lockStatus">
							<el-select :clearable=true v-model="lockDevicInfo.lockStatus" :filterable=true
								placeholder="请选择">
								<el-option v-for="item in lockStatuOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="车锁类型:" prop="bicycleType">
							<el-select :clearable=true v-model="lockDevicInfo.bicycleType" :filterable=true
								placeholder="请选择" @change="handleEditBicycleTypeChange">
								<el-option v-for="item in bicycleTypeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="车辆类型:" prop="deviceType">
							<el-select :clearable=true v-model="lockDevicInfo.deviceType" :filterable=true
								placeholder="请选择">
								<el-option v-for="item in deviceTypeOptions" :key="item.deviceTypeCode" :label="item.deviceTypeName"
									:value="item.deviceTypeCode">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="定位方式:" prop="positionMode">
							<el-select :clearable=true v-model="lockDevicInfo.positionMode" :filterable=true
								placeholder="请选择">
								<el-option v-for="item in positionModeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="协议类型:" prop="protocolType">
							<el-select :clearable=true v-model="lockDevicInfo.protocolType" :filterable=true
								placeholder="请选择">
								<el-option v-for="item in protocolTypeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="lockDevicInfo.protocolType === 2 || lockDevicInfo.protocolType === 3">
						<el-form-item label="锁密钥:" prop="lockPassword">
							<el-input v-model.trim="lockDevicInfo.lockPassword" placeholder="义卫士蓝牙开锁密钥表(80字符)" maxlength="80" show-word-limit type="textarea" :rows="2"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否开启自定义语音:" prop="enableCustomVoice">
							<el-select :clearable=true v-model="lockDevicInfo.enableCustomVoice" placeholder="请选择">
								<el-option label="开启" :value="1"></el-option>
								<el-option label="关闭" :value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="关锁语音:" prop="lockVoiceContent">
							<el-input v-model.trim="lockDevicInfo.lockVoiceContent" placeholder="不超过100个汉字" maxlength="100" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="围栏内还车语音:" prop="fenceReturnVoiceContent">
							<el-input v-model.trim="lockDevicInfo.fenceReturnVoiceContent" placeholder="不超过100个汉字" maxlength="100" show-word-limit></el-input>
						</el-form-item>
					</el-col>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="updateLockDeviceDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="updateLockDevice()">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 车锁信息添加 -->
			<el-dialog title="车锁信息添加" :visible.sync="addLockDevicDialogVisible" width="800px">
				<el-form :model="lockDevicInfo" status-icon :rules="addLockDeviceRules" ref="lockDevicInfoAdd"
					label-width="100px" class="demo-ruleForm" style="padding-right: 50px;">
					<el-col :span="12">
						<el-form-item label="锁编号:" prop="qrNumber">
							<el-input v-model.trim="lockDevicInfo.qrNumber"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="IMEI:" prop="imei">
							<el-input v-model.trim="lockDevicInfo.imei" type="text" size="small"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="Mac地址:" prop="mac">
							<el-input v-model.trim="lockDevicInfo.mac" type="text" size="small"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="UUID:" prop="uuid">
							<el-input v-model.trim="lockDevicInfo.uuid"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="Sim卡:" prop="sim">
							<el-input v-model.trim="lockDevicInfo.sim"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="经度:" prop="longitude">
							<el-input v-model.trim="lockDevicInfo.longitude"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="纬度:" prop="latitude">
							<el-input v-model.trim="lockDevicInfo.latitude"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="主电量:" prop="mainElectricity">
							<el-input v-model.trim="lockDevicInfo.mainElectricity"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="副电量:" prop="viceElectricity">
							<el-input v-model.trim="lockDevicInfo.viceElectricity"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="二维码链接:" prop="qrCode">
							<el-input v-model.trim="lockDevicInfo.qrCode"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="设备状态:" prop="lockStatus">
							<el-select :clearable=true v-model="lockDevicInfo.lockStatus" :filterable=true
								placeholder="请选择">
								<el-option v-for="item in lockStatuOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="车锁类型:" prop="bicycleType">
							<el-select :clearable=true v-model="lockDevicInfo.bicycleType" :filterable=true
								placeholder="请选择" @change="handleAddBicycleTypeChange">
								<el-option v-for="item in bicycleTypeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="车辆类型:" prop="deviceType">
							<el-select :clearable=true v-model="lockDevicInfo.deviceType" :filterable=true
								placeholder="请选择">
								<el-option v-for="item in deviceTypeOptions" :key="item.deviceTypeCode" :label="item.deviceTypeName"
									:value="item.deviceTypeCode">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="定位方式:" prop="positionMode">
							<el-select :clearable=true v-model="lockDevicInfo.positionMode" :filterable=true
								placeholder="请选择">
								<el-option v-for="item in positionModeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="协议类型:" prop="protocolType">
							<el-select :clearable=true v-model="lockDevicInfo.protocolType" :filterable=true
								placeholder="请选择">
								<el-option v-for="item in protocolTypeOptions" :key="item.key" :label="item.value"
									:value="item.key">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12" v-if="lockDevicInfo.protocolType === 2 || lockDevicInfo.protocolType === 3">
						<el-form-item label="锁密钥:" prop="lockPassword">
							<el-input v-model.trim="lockDevicInfo.lockPassword" placeholder="义卫士蓝牙开锁密钥表(80字符)" maxlength="80" show-word-limit type="textarea" :rows="2"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="是否开启自定义语音:" prop="enableCustomVoice">
							<el-select :clearable=true v-model="lockDevicInfo.enableCustomVoice" placeholder="请选择">
								<el-option label="开启" :value="1"></el-option>
								<el-option label="关闭" :value="0"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="关锁语音:" prop="lockVoiceContent">
							<el-input v-model.trim="lockDevicInfo.lockVoiceContent" placeholder="不超过100个汉字" maxlength="100" show-word-limit></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label="围栏内还车语音:" prop="fenceReturnVoiceContent">
							<el-input v-model.trim="lockDevicInfo.fenceReturnVoiceContent" placeholder="不超过100个汉字" maxlength="100" show-word-limit></el-input>
						</el-form-item>
					</el-col>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="addLockDevicDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="addLockDevice()">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 车锁分配 -->
			<el-dialog title="车锁分配" :visible.sync="initLockDeviceAllocationDialogVisible" width="900px">
				<el-form :model="lockDevicInfo" label-width="100px" class="demo-ruleForm" style="padding-right: 50px;">
					<el-form-item label="运营商:" prop="name">
						<el-select :clearable=true v-model="allotLockDeviceInfo.distributorId" :filterable=true
							placeholder="请选择">
							<el-option v-for="item in distributorOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
					
					<el-form-item label="设备搜索:" class="no-margin-bottom">
					<el-input 
						v-model="undistributedSearch" 
						placeholder="请输入锁编号或IMEI号搜索" 
						style="width: 300px;"
						@keyup.enter.native="searchDevices"
					>
					</el-input>
					<el-button type="primary" size="small" style="margin-left: 10px;" @click="searchDevices">搜索</el-button>
					<el-button size="small" style="margin-left: 5px;" @click="clearSearch">清空</el-button>
				</el-form-item>
					<el-form-item label="锁设备:" class="no-margin-bottom" style="margin-top: 10px;">
						<div style="margin-bottom: 10px;">
							<el-badge :value="selectedDevices.length" type="danger">
								<span>已选择设备</span>
							</el-badge>
							<span v-if="selectedDevices.length > 0" style="margin-left: 10px; color: #606266;">
								(筛选后共 {{ filteredUndistributedDevices.length }} 台设备)
							</span>
						</div>
						<el-table 
					:data="paginatedDevices" 
					border 
					stripe 
					@selection-change="handleDeviceSelectionChange"
					@select="handleDeviceSelect"
					@select-all="handleDeviceSelectAll"
					max-height="400" 
					style="margin-top: 10px;"
					ref="deviceTable">
					<el-table-column type="selection" width="55"></el-table-column>
					<el-table-column type="index" width="60"></el-table-column>
					<el-table-column prop="qrNumber" label="锁编号"></el-table-column>
					<el-table-column prop="imei" label="IMEI"></el-table-column>
					<el-table-column prop="mainElectricity" label="主电量"></el-table-column>
					<el-table-column prop="positionMode" label="定位方式">
						<template slot-scope="scope">
							{{ scope.row.positionMode == 1 ? '基站定位' : (scope.row.positionMode == 2 ? 'GPS定位' : (scope.row.positionMode == 3 ? '手机定位' : '未知')) }}
						</template>
					</el-table-column>
					<el-table-column prop="lastOnlineTime" label="最后在线时间" width="180"></el-table-column>
				</el-table>
					<el-pagination
						style="margin-top: 15px; text-align: right;"
						background
						layout="prev, pager, next, jumper, sizes, total"
						:total="filteredUndistributedDevices.length"
						:page-size="pagination.pageSize"
						:current-page="pagination.currentPage"
						@size-change="handleAllocationSizeChange"
						@current-change="handleAllocationCurrentChange"
					/>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="initLockDeviceAllocationDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="LockDeviceAllocation()" :disabled="selectedDevices.length === 0">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 开锁指令对话框 -->
			<el-dialog title="开锁指令" :visible.sync="unlockDialogVisible" width="500px">
				<el-form :model="unlockForm" label-width="100px">
					<el-form-item label="设备IMEI:">
						<el-input v-model="unlockForm.imei" disabled></el-input>
					</el-form-item>
					<el-form-item label="音乐类型:">
						<el-select v-model="unlockForm.music" placeholder="请选择">
							<el-option label="静音" :value="100"></el-option>
							<el-option label="音乐1" :value="1"></el-option>
							<el-option label="音乐2" :value="2"></el-option>
							<el-option label="音乐3" :value="3"></el-option>
							<el-option label="音乐4" :value="4"></el-option>
							<el-option label="音乐5" :value="5"></el-option>
							<el-option label="音乐6" :value="6"></el-option>
							<el-option label="音乐7" :value="7"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="通道类型:">
						<el-select v-model="unlockForm.channel" placeholder="请选择">
							<el-option label="普通开锁" :value="1"></el-option>
							<el-option label="开坐桶锁" :value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="unlockDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendUnlockCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 关锁指令对话框 -->
			<el-dialog title="下发关锁指令" :visible.sync="lockDialogVisible" width="30%">
				<el-form :model="lockForm" label-width="120px">
					<el-form-item label="设备IMEI">
						<el-input v-model="lockForm.imei" disabled></el-input>
					</el-form-item>
					<el-form-item label="关锁模式">
						<el-select v-model="lockForm.mode" placeholder="请选择关锁模式">
							<el-option label="标准模式" :value="1"></el-option>
							<el-option label="强制模式" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="音乐类型">
						<el-select v-model="lockForm.music" placeholder="请选择音乐类型">
							<el-option label="不播放" :value="0"></el-option>
							<el-option label="播放013类型声音" :value="1"></el-option>
							<el-option label="播放015类型声音" :value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<div slot="footer" class="dialog-footer">
					<el-button @click="lockDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendLockCommand">确 定</el-button>
				</div>
			</el-dialog>

			<!-- 切换IP指令对话框 -->
			<el-dialog title="切换IP指令" :visible.sync="switchIpDialogVisible" width="500px">
				<el-form :model="switchIpForm" label-width="100px">
					<el-form-item label="设备IMEI:">
						<el-input v-model="switchIpForm.imei" disabled></el-input>
					</el-form-item>
					<el-form-item label="类型:">
						<el-select v-model="switchIpForm.type" placeholder="请选择">
							<el-option label="IP地址" :value="0"></el-option>
							<el-option label="域名" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="IP/域名:">
						<el-input v-model="switchIpForm.ip" placeholder="请输入IP地址或域名"></el-input>
					</el-form-item>
					<el-form-item label="端口:">
						<el-input-number v-model="switchIpForm.port" :min="1" :max="65535"
							placeholder="请输入端口号"></el-input-number>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="switchIpDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendSwitchIpCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 批量开锁对话框 -->
			<el-dialog title="批量开锁" :visible.sync="batchUnlockDialogVisible" width="500px">
				<el-form :model="batchUnlockForm" label-width="100px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="音乐类型">
						<el-select v-model="batchUnlockForm.music" placeholder="请选择音乐类型">
							<el-option label="音乐0" :value="0"></el-option>
							<el-option label="音乐1" :value="1"></el-option>
							<el-option label="音乐2" :value="2"></el-option>
							<el-option label="音乐3" :value="3"></el-option>
							<el-option label="音乐4" :value="4"></el-option>
							<el-option label="音乐5" :value="5"></el-option>
							<el-option label="音乐6" :value="6"></el-option>
							<el-option label="音乐7" :value="7"></el-option>
							<el-option label="静音" :value="100"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="通道类型">
						<el-select v-model="batchUnlockForm.channel" placeholder="请选择通道类型">
							<el-option label="普通开锁" :value="1"></el-option>
							<el-option label="开坐桶锁" :value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchUnlockDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendBatchUnlockCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 批量关锁对话框 -->
			<el-dialog title="批量关锁" :visible.sync="batchLockDialogVisible" width="500px">
				<el-form :model="batchLockForm" label-width="100px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="关锁模式">
						<el-select v-model="batchLockForm.mode" placeholder="请选择关锁模式">
							<el-option label="标准模式" :value="1"></el-option>
							<el-option label="强制模式" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="音乐类型">
						<el-select v-model="batchLockForm.music" placeholder="请选择音乐类型">
							<el-option label="不播放声音" :value="0"></el-option>
							<el-option label="播放013类型声音" :value="1"></el-option>
							<el-option label="播放015类型声音" :value="2"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchLockDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendBatchLockCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 批量切换IP对话框 -->
			<el-dialog title="批量切换IP" :visible.sync="batchSwitchIpDialogVisible" width="500px">
				<el-form :model="batchSwitchIpForm" label-width="100px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="类型">
						<el-select v-model="batchSwitchIpForm.type" placeholder="请选择类型">
							<el-option label="IP地址" :value="0"></el-option>
							<el-option label="域名" :value="1"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="IP/域名">
						<el-input v-model="batchSwitchIpForm.ip" placeholder="请输入IP地址或域名"></el-input>
					</el-form-item>
					<el-form-item label="端口号">
						<el-input v-model="batchSwitchIpForm.port" placeholder="请输入端口号"></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchSwitchIpDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendBatchSwitchIpCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 批量定位对话框 -->
			<el-dialog title="批量定位" :visible.sync="batchLocateDialogVisible" width="500px">
				<el-form :model="batchLocateForm" label-width="100px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="定位模式">
						<el-select v-model="batchLocateForm.mode" placeholder="请选择定位模式">
							<el-option label="GPS定位" :value="1"></el-option>
							<el-option label="基站定位" :value="2"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="定位时间(秒)">
						<el-input-number v-model="batchLocateForm.time" :min="60" :max="18000"
							placeholder="请输入定位时间"></el-input-number>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchLocateDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendBatchLocateCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 批量撤销分配对话框 -->
			<el-dialog title="批量撤销分配" :visible.sync="batchRevokeAllocationDialogVisible" width="600px">
				<el-form label-width="100px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="设备列表">
							<el-table :data="multipleSelection" border stripe max-height="300">
								<el-table-column type="index" width="60"></el-table-column>
								<el-table-column prop="qrNumber" label="锁编号"></el-table-column>
								<el-table-column prop="imei" label="IMEI"></el-table-column>
								<el-table-column prop="isAllot" label="分配状态">
									<template slot-scope="scope">
										<span :style="{ color: scope.row.isAllot == 1 ? '#67C23A' : '#F56C6C' }">
											{{ scope.row.isAllot == 1 ? '已分配' : '未分配' }}
										</span>
									</template>
								</el-table-column>
							</el-table>
						</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchRevokeAllocationDialogVisible = false">取 消</el-button>
					<el-button type="warning" @click="sendBatchRevokeAllocationCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 批量修改车锁类型对话框 -->
			<el-dialog title="批量修改车锁类型" :visible.sync="batchModifyBicycleTypeDialogVisible" width="500px">
				<el-form :model="batchModifyBicycleTypeForm" label-width="100px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="车锁类型">
						<el-select v-model="batchModifyBicycleTypeForm.bicycleType" placeholder="请选择车锁类型">
							<el-option v-for="item in bicycleTypeOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchModifyBicycleTypeDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendBatchModifyBicycleTypeCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 批量修改协议类型对话框 -->
			<el-dialog title="批量修改协议类型" :visible.sync="batchModifyProtocolTypeDialogVisible" width="500px">
				<el-form :model="batchModifyProtocolTypeForm" label-width="100px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="协议类型">
						<el-select v-model="batchModifyProtocolTypeForm.protocolType" placeholder="请选择协议类型">
							<el-option v-for="item in protocolTypeOptions" :key="item.key" :label="item.value"
								:value="item.key">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchModifyProtocolTypeDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendBatchModifyProtocolTypeCommand">确 定</el-button>
				</span>
			</el-dialog>

			<el-dialog title="批量修改车辆类型" :visible.sync="batchModifyDeviceTypeDialogVisible" width="500px">
				<el-form :model="batchModifyDeviceTypeForm" label-width="100px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="车辆类型">
						<el-select v-model="batchModifyDeviceTypeForm.deviceType" placeholder="请选择车辆类型">
							<el-option v-for="item in allDeviceTypeList" :key="item.deviceTypeCode" :label="item.deviceTypeName"
								:value="item.deviceTypeCode">
							</el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchModifyDeviceTypeDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendBatchModifyDeviceTypeCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 批量休眠对话框 -->
			<el-dialog title="批量休眠" :visible.sync="batchSleepDialogVisible" width="500px">
				<el-form :model="batchSleepForm" label-width="100px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="休眠模式">
						<el-select v-model="batchSleepForm.mode" placeholder="请选择休眠模式">
							<el-option label="开锁休眠(发货模式)" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="休眠时长(秒)" v-if="batchSleepForm.mode === 5">
						<el-input-number v-model="batchSleepForm.time" :min="60" :max="18000"
							placeholder="请输入休眠时长"></el-input-number>
						<span style="margin-left: 10px; color: #909399; font-size: 12px;">(60-18000秒)</span>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchSleepDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendBatchSleepCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 批量设置语音播报对话框 -->
			<el-dialog title="批量设置语音播报" :visible.sync="batchSetVoiceDialogVisible" width="500px">
				<el-form :model="batchSetVoiceForm" label-width="120px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="语音类型">
						<el-select v-model="batchSetVoiceForm.voiceType" placeholder="请选择语音类型">
							<el-option label="开锁成功语音" :value="1"></el-option>
							<el-option label="开锁失败语音" :value="2"></el-option>
							<el-option label="关锁成功语音" :value="3"></el-option>
							<el-option label="关锁失败语音" :value="4"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="语音内容">
						<el-input v-model="batchSetVoiceForm.voiceContent" placeholder="请输入语音内容(不超过200个汉字)" maxlength="200" show-word-limit></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchSetVoiceDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendBatchSetVoiceCommand">确 定</el-button>
				</span>
			</el-dialog>

			<!-- 批量修改自定义语音播报对话框 -->
			<el-dialog title="批量修改自定义语音播报" :visible.sync="batchModifyCustomVoiceDialogVisible" width="500px">
				<el-form :model="batchModifyCustomVoiceForm" label-width="160px">
					<el-form-item label="选中设备数量">
						<el-input :value="multipleSelection.length" disabled></el-input>
					</el-form-item>
					<el-form-item label="是否开启自定义语音播报">
						<el-select v-model="batchModifyCustomVoiceForm.enableCustomVoice" placeholder="请选择">
							<el-option label="开启" :value="1"></el-option>
							<el-option label="关闭" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="关锁语音播报">
						<el-input v-model="batchModifyCustomVoiceForm.lockVoiceContent" placeholder="请输入关锁语音播报内容(不超过200个汉字)" maxlength="200" show-word-limit></el-input>
					</el-form-item>
					<el-form-item label="围栏内还车语音播报">
						<el-input v-model="batchModifyCustomVoiceForm.fenceReturnVoiceContent" placeholder="请输入围栏内还车语音播报内容(不超过200个汉字)" maxlength="200" show-word-limit></el-input>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button @click="batchModifyCustomVoiceDialogVisible = false">取 消</el-button>
					<el-button type="primary" @click="sendBatchModifyCustomVoiceCommand">确 定</el-button>
				</span>
			</el-dialog>

			<el-dialog title="车辆轨迹" :visible.sync="trackDialogVisible" width="900px" @close="closeTrackDialog">
				<div class="track-dialog-content">
					<div class="track-search-bar">
						<el-date-picker
							v-model="trackDateRange"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							size="small"
							value-format="yyyyMMdd"
							:picker-options="trackPickerOptions"
							style="margin-right: 10px;"
						></el-date-picker>
						<el-button size="small" type="primary" icon="el-icon-search" @click="loadTrackData" :loading="trackLoading">查询</el-button>
						<span class="track-info" v-if="trackPoints.length > 0" style="margin-left: 10px;">共 {{trackPoints.length}} 个轨迹点</span>
						<template v-if="trackPath.length > 1">
							<el-button size="small" :type="trackPlaying ? 'danger' : 'success'" :icon="trackPlaying ? 'el-icon-video-pause' : 'el-icon-video-play'" @click="toggleTrackPlay" style="margin-left: 10px;">{{trackPlaying ? '暂停' : '回放'}}</el-button>
							<el-button size="small" icon="el-icon-refresh-left" @click="resetTrackPlay">重置</el-button>
							<span class="track-speed-label">速度:</span>
							<el-slider v-model="trackSpeed" :min="1" :max="10" :step="1" style="width: 100px; margin: 0 10px;" />
							<span class="track-progress">{{trackCurrentIndex}} / {{trackPath.length}}</span>
						</template>
					</div>
					<div id="track_map_view" class="track-map-container"></div>
				</div>
			</el-dialog>
		</el-card>
	</div>
</template>

<script>
import { getCurrentDistributorId } from '@/utils/distributor.js'

export default {
	data() {
		return {
			user: '',
			isAdmin: false,
			allotStatusOptions: [{
				key: 0,
				value: '未分配'
			}, {
				key: 1,
				value: '已分配'
			}],
			operatorOptions: [{
				key: 1,
				value: '中国移动'
			}, {
				key: 2,
				value: '中国联通'
			}, {
				key: 3,
				value: '中国电信'
			}],
			allotLockDeviceInfo: {},
			undistributedSearch: '',
			undistributedDevicesList: [],
			selectedDevices: [],
			// 分页相关数据
			pagination: {
				currentPage: 1,
				pageSize: 8,
				total: 0
			},
			distributorOptions: [],
			lockDevicePageInfoReq: {
				page: 1,
				limit: 8,
				qrNumber: '',
				imei: '',
				positionMode: '',
				distributorId: '',
				bicycleType: '',
				protocolType: '',
				deviceType: '',
				queryDistributorId: '',
				orderByField: '',
				isAsc: null,
				lockStatus: '',
				isValid: null
			},
			lockDeviceList: [],
			total: 0,
			lockStatuOptions: [{
				key: 1,
				value: '开锁'
			}, {
				key: 2,
				value: '关锁'
			}],
			lockStatusOptions: [{
				key: 1,
				value: '开锁'
			}, {
				key: 2,
				value: '关锁'
			}],
			positionModeOptions: [{
				key: 1,
				value: '基站定位'
			}, {
				key: 2,
				value: 'GPS定位'
			}, {
				key: 3,
				value: '手机定位'
			}],
			bicycleTypeOptions: [{
				key: 1,
				value: '自行车'
			}, {
				key: 2,
				value: '电动车'
			}, {
				key: 3,
				value: '涨闸锁'
			}],
			protocolTypeOptions: [{
				key: 1,
				value: '友信智联协议'
			}, {
				key: 2,
				value: '义卫士4G协议'
			}, {
				key: 3,
				value: '义卫士蓝牙协议'
			}],
			allDeviceTypeList: [],
			deviceTypeOptions: [],
			undistributedLockDeviceOptions: [],
			// 车锁信息修改弹框
			updateLockDeviceDialogVisible: false,
			addLockDevicDialogVisible: false,
			initLockDeviceAllocationDialogVisible: false,
			// 指令下发弹框
			unlockDialogVisible: false,
			lockDialogVisible: false,
			switchIpDialogVisible: false,
			// 指令表单数据
			unlockForm: {
				id: '',
				imei: '',
				music: 1,
				channel: 1
			},
			lockForm: {
				id: '',
				imei: '',
				mode: 'STAND',
				music: 1
			},
			switchIpForm: {
				id: '',
				imei: '',
				ip: '',
				port: 6008,
				type: 0
			},
			// 批量操作相关数据
			multipleSelection: [],
			// 跨分页选择的设备ID集合
			allSelectedDeviceIds: new Set(),
			// 是否正在全选操作中
			isSelectingAll: false,
			// 是否全选所有设备
			isAllSelected: false,
			// 批量操作对话框显示状态
			batchUnlockDialogVisible: false,
			batchLockDialogVisible: false,
			batchSwitchIpDialogVisible: false,
			batchLocateDialogVisible: false,
			batchRevokeAllocationDialogVisible: false,
			batchModifyBicycleTypeDialogVisible: false,
			batchModifyProtocolTypeDialogVisible: false,
			batchModifyDeviceTypeDialogVisible: false,
			batchSleepDialogVisible: false,
			batchSetVoiceDialogVisible: false,
			batchModifyCustomVoiceDialogVisible: false,
			// 批量操作表单数据
			batchUnlockForm: {
				music: 1,
				channel: 1
			},
			batchLockForm: {
				mode: 1, // 1表示STAND标准模式
				music: 1
			},
			batchSwitchIpForm: {
				ip: '',
				port: 6008,
				type: 0
			},
			batchLocateForm: {
				mode: 1, // 1表示GPS定位，2表示基站定位
				time: 300 // 默认5分钟
			},
			batchModifyBicycleTypeForm: {
				bicycleType: null
			},
			batchModifyProtocolTypeForm: {
				protocolType: null
			},
			batchModifyDeviceTypeForm: {
				deviceType: null
			},
			batchSleepForm: {
				mode: 0,
				time: 300
			},
			batchSetVoiceForm: {
				voiceType: null,
				voiceContent: ''
			},
			batchModifyCustomVoiceForm: {
				enableCustomVoice: null,
				lockVoiceContent: '',
				fenceReturnVoiceContent: ''
			},
			lockDevicInfo: {},
			undistributedLockDeviceList: [],
			addLockDeviceRules: {
				//验证用户名是否合法
				qrNumber: [{
					required: true,
					message: '请输入锁编号',
					trigger: ['blur', 'change'],
				},
				{
					min: 1,
					max: 32,
					message: '长度在 1 到 32 个字符',
					trigger: ['blur', 'change'],
				}],
				imei: [{
					required: true,
					message: '请输入imei',
					trigger: ['blur', 'change'],
				},
				{
					min: 1,
					max: 32,
					message: '长度在 1 到 32 个字符',
					trigger: ['blur', 'change'],
				}],
				mainElectricity: [
					{
						pattern: /^(\d|[1-9]\d|100)(\.\d{1,2})?$/,
						min: 0,
						max: 100,
						message: '主电量为 0 ~ 100 的数字',
						trigger: "blur"
					},
				],
				viceElectricity: [
					{
						pattern: /^(\d|[1-9]\d|100)(\.\d{1,2})?$/,
						min: 0,
						max: 100,
						message: '副电量为 0 ~ 100 的数字',
						trigger: "blur"
					},
				],
				operator: [
					{
						required: true,
						message: '请选择运营商',
						trigger: ['blur', 'change'],
					}
				]


			},
			trackDialogVisible: false,
			trackImei: '',
			trackPoints: [],
			trackPath: [],
			trackLoading: false,
			trackMap: null,
			trackPolyline: null,
			trackMarkerLayer: null,
			trackLabelLayer: null,
			trackDotLayer: null,
			trackInfoWindow: null,
			trackPointInfos: [],
			trackPlaying: false,
			trackCurrentIndex: 0,
			trackSpeed: 5,
			trackTimer: null,
			trackMoveMarker: null,
			trackStartMarker: null,
			trackEndMarker: null,
			trackDateRange: null,
			trackPickerOptions: {
				shortcuts: [{
					text: '今天',
					onClick(picker) {
						var start = new Date();
						picker.$emit('pick', [start, start]);
					}
				}, {
					text: '最近3天',
					onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 2 * 24 * 3600 * 1000);
						picker.$emit('pick', [start, end]);
					}
				}, {
					text: '最近7天',
					onClick(picker) {
						var end = new Date();
						var start = new Date();
						start.setTime(start.getTime() - 6 * 24 * 3600 * 1000);
						picker.$emit('pick', [start, end]);
					}
				}]
			},
		}
	},
	computed: {
		currentUser() {
			return this.user; // 假设 user 是 Vue 实例的一个数据属性
		},
		// 过滤后的未分配设备列表
		filteredUndistributedDevices() {
			if (!this.undistributedSearch.trim()) {
				// 如果搜索框为空，返回所有设备
				return this.undistributedDevicesList;
			}
			
			// 过滤包含搜索关键词的设备
			const keyword = this.undistributedSearch.toLowerCase();
			return this.undistributedDevicesList.filter(device => 
				(device.imei && device.imei.toLowerCase().includes(keyword)) ||
				(device.qrNumber && device.qrNumber.toLowerCase().includes(keyword)) ||
				(device.sn && device.sn.toLowerCase().includes(keyword))
			);
		},
		// 分页后的设备列表
		paginatedDevices() {
			const filtered = this.filteredUndistributedDevices;
			const start = (this.pagination.currentPage - 1) * this.pagination.pageSize;
			const end = start + this.pagination.pageSize;
			return filtered.slice(start, end);
		}
	},
	created() {
		this.user = window.sessionStorage.getItem('user');
		this.isAdmin = window.sessionStorage.getItem('isAdmin') === 'true';

		// 动态添加经度和纬度的验证规则
		this.$set(this.addLockDeviceRules, 'longitude', [{
			validator: this.validatorLongitude,
			message: "经度范围：-180~180（保留小数点后十五位）",
			trigger: ['blur', 'change'],
		}]);

		this.$set(this.addLockDeviceRules, 'latitude', [{
			validator: this.validatorLatitude,
			message: "纬度范围：-90~90（保留小数点后十五位）",
			trigger: ['blur', 'change'],
		}]);

		this.getDistributorOptions();
		this.getAllDeviceTypeList();
		
		// 设置运营商过滤参数
		this.lockDevicePageInfoReq.queryDistributorId = getCurrentDistributorId()
		this.getlockDeviceList()
		
		// 监听运营商切换事件
		this.$root.$on('distributorChanged', this.handleDistributorChange)
	},
	beforeDestroy() {
		// 移除事件监听
		this.$root.$off('distributorChanged', this.handleDistributorChange)
	},
	methods: {
		handleDistributorChange(distributorId) {
			this.lockDevicePageInfoReq.queryDistributorId = distributorId || ''
			this.lockDevicePageInfoReq.page = 1
			this.getlockDeviceList()
		},
		getAllDeviceTypeList() {
			this.$http.get('/device/typeConfig/getAllList').then((res) => {
				if (res.data.code === 200) {
					this.allDeviceTypeList = res.data.data || [];
				}
			});
		},
		getDeviceTypeOptions(deviceType) {
			if (!deviceType) {
				this.deviceTypeOptions = [];
				return;
			}
			this.deviceTypeOptions = this.allDeviceTypeList.filter(item => item.bicycleType === deviceType);
		},
		getDeviceTypeName(deviceType) {
			if (!deviceType) return '-';
			const item = this.allDeviceTypeList.find(d => d.deviceTypeCode === deviceType);
			return item ? item.deviceTypeName : '-';
		},
		async getlockDeviceList() {
			const {
				data: res
			} = await this.$http.post(
				'/device/manager/getLockDevicePageInfo', this.lockDevicePageInfoReq)
			if (res.code != 200) return this.$message.error(res.msg)
			this.lockDeviceList = res.data.list
			this.total = res.data.total
		},
		reGetlockDeviceList() {
			if (this.lockDevicePageInfoReq.startDate == null || this.lockDevicePageInfoReq.endDate == null) {
				this.lockDevicePageInfoReq.startDate = ''
				this.lockDevicePageInfoReq.endDate = ''
			}
			this.lockDevicePageInfoReq.page = 1;
			this.getlockDeviceList();
		},
		handleSortChange({ prop, order }) {
			if (order) {
				this.lockDevicePageInfoReq.orderByField = prop;
				this.lockDevicePageInfoReq.isAsc = order === 'ascending';
			} else {
				this.lockDevicePageInfoReq.orderByField = '';
				this.lockDevicePageInfoReq.isAsc = null;
			}
			this.getlockDeviceList();
		},
		// 获取运营商选项
		getDistributorOptions() {
			this.$http.get('/distributor/manager/getAllDistributorInfo').then((res) => {
				this.distributorOptions = [];
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let distributorInfoList = res.data.data;
				for (let index in distributorInfoList) {
					this.distributorOptions.push({ key: distributorInfoList[index].id, value: distributorInfoList[index].name });
				}
			});
		},
		getDistributorName(distributorId) {
			if (!distributorId) return '';
			const item = this.distributorOptions.find(d => d.key === distributorId);
			return item ? item.value : '';
		},
		getDeviceTypeOptions(bicycleType) {
			if (!bicycleType) {
				this.deviceTypeOptions = [];
				return;
			}
			this.$http.get('/device/typeConfig/getAllList').then((res) => {
				if (res.data.code === 200) {
					let allList = res.data.data || [];
					this.deviceTypeOptions = allList.filter(item => item.bicycleType === bicycleType);
				}
			});
		},
		handleBicycleTypeChange(val) {
			this.lockDevicePageInfoReq.deviceType = '';
			this.getDeviceTypeOptions(val);
		},
		//监听pagesize变化
		handleSizeChange(pageSize) {
			this.lockDevicePageInfoReq.limit = pageSize
			this.getlockDeviceList()
		},
		//监听页数变化
		handleCurrentChange(pageNum) {
			this.lockDevicePageInfoReq.page = pageNum
			this.getlockDeviceList()
		},
		async updateLockDeviceInit(id) {
			const {
				data: res
			} = await this.$http.get(
				'/device/manager/getLockDeviceById/' + id)
			if (res.code != 200) return this.$message.error(res.msg)
			this.lockDevicInfo = res.data
			if (this.lockDevicInfo.bicycleType) {
				this.getDeviceTypeOptions(this.lockDevicInfo.bicycleType);
			}
			this.updateLockDeviceDialogVisible = true
		},
		handleEditBicycleTypeChange(val) {
			this.lockDevicInfo.deviceType = '';
			this.getDeviceTypeOptions(val);
		},
		handleAddBicycleTypeChange(val) {
			this.lockDevicInfo.deviceType = '';
			this.getDeviceTypeOptions(val);
		},
		updateLockDevice() {
			this.$refs.lockDevicInfoUpdate.validate((valid) => {
				if (valid) {
					this.$http.post('/device/manager/updateLockDeviceById', this.lockDevicInfo).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.updateLockDeviceDialogVisible = false;
						this.reGetlockDeviceList();
						this.$message.success(res.data.msg);
					})
				} else {
					return false;
				}
			});
		},
		initLockDevice() {
			this.lockDevicInfo = {};
			this.addLockDevicDialogVisible = true;
		},
		addLockDevice() {
			this.$refs.lockDevicInfoAdd.validate((valid) => {
				if (valid) {
					this.$http.post('/device/manager/addLockDevice', this.lockDevicInfo).then((res) => {
						if (res.data.code != 200) return this.$message.error(res.data.msg);
						this.addLockDevicDialogVisible = false;
						this.reGetlockDeviceList();
						this.$message.success(res.data.msg);
					})
				} else {
					return false;
				}
			});
		},
		deleteLockDevice(id, qrNumber) {
			this.$confirm("确认删除锁编号为 " + qrNumber + " 数据吗？", {
				title: "提示",
				type: 'warning',
			}).then(resc => {
				this.$http.get('/device/manager/deleteLockDeviceById/' + id).then((res) => {
					if (res.data.code != 200) return this.$message.error(res.data.msg);
					this.reGetlockDeviceList();
					this.$message.success(res.data.msg);
				})
			})

		},
		//经度
		validatorLongitude: (rule, value, callback) => {
			const reg = /^(\-|\+)?(((\d|[1-9]\d|1[0-7]\d|0{1,3})\.\d{0,15})|(\d|[1-9]\d|1[0-7]\d|0{1,3})|180\.0{0,15}|180)$/
			if (value === "" || value == undefined) {
				callback();
			} else {
				if (!reg.test(value)) {
					callback(new Error('经度范围：-180~180（保留小数点后十五位）'));
				}
				callback();
			}
		},
		//纬度
		validatorLatitude: (rule, value, callback) => {
			const reg = /^(\-|\+)?([0-8]?\d{1}\.\d{0,15}|90\.0{0,15}|[0-8]?\d{1}|90)$/
			if (value === "" || value == undefined) {
				callback();
			} else {
				if (!reg.test(value)) {
					callback(new Error('纬度范围：-90~90（保留小数点后十五位）'));
				}
				callback();
			}
		},
		// 初始化车锁分配弹框
		initLockDeviceAllocation() {
			this.allotLockDeviceInfo = {};
			this.selectedDevices = [];
			this.allSelectedDeviceIds.clear();
			this.isAllSelected = false;
			this.undistributedSearch = '';
			this.pagination = {
				currentPage: 1,
				pageSize: 20
			};
			this.$http.get('/device/manager/getAllUndistributedLockDeviceInfo').then((res) => {
				this.undistributedLockDeviceOptions = [];
				this.undistributedDevicesList = [];
				if (res.data.code != 200) return this.$message.error(res.data.msg);
				let lockDeviceInfoList = res.data.data;
				// 保存完整的设备信息列表
				this.undistributedDevicesList = lockDeviceInfoList;
				// 同时为兼容性保留下拉选项格式
				for (let index in lockDeviceInfoList) {
					this.undistributedLockDeviceOptions.push({ key: lockDeviceInfoList[index].id, value: lockDeviceInfoList[index].imei });
				}
			});
			this.initLockDeviceAllocationDialogVisible = true;
		},
		// 车锁分配保存
		LockDeviceAllocation() {
			if (!this.allotLockDeviceInfo.distributorId) {
				return this.$message.warning('请选择运营商');
			}
			
			// 准备提交数据，将选中的设备ID保存到deviceIdList
			const deviceIdList = this.selectedDevices.map(item => item.id);
			const submitData = {
				distributorId: this.allotLockDeviceInfo.distributorId,
				deviceIdList: deviceIdList
			};
			
			this.$confirm(`确认分配选中的 ${deviceIdList.length} 台设备吗？`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post('/device/manager/lockDeviceAllocation', submitData).then((res) => {
					if (res.data.code != 200) return this.$message.error(res.data.msg);
					this.reGetlockDeviceList();
					this.initLockDeviceAllocationDialogVisible = false;
					this.$message.success(`车锁分配成功，共分配${deviceIdList.length}台设备`);
				})
			}).catch(() => {
				this.$message.info('已取消分配');
			});
		},
		// 处理设备选择变化
		handleDeviceSelectionChange(val) {
			// 获取当前页选中的设备ID
			const currentPageSelectedIds = new Set(val.map(item => item.id));
			
			// 更新全局选中的设备ID集合
			this.allSelectedDeviceIds.clear();
			
			if (this.isAllSelected) {
				// 如果是全选状态，添加所有过滤后的设备ID
				this.filteredUndistributedDevices.forEach(device => {
					this.allSelectedDeviceIds.add(device.id);
				});
				// 移除当前页取消选择的设备ID
				this.filteredUndistributedDevices.forEach(device => {
					if (!currentPageSelectedIds.has(device.id)) {
						this.allSelectedDeviceIds.delete(device.id);
					}
				});
				
				// 检查是否还有选中的设备
				this.isAllSelected = this.allSelectedDeviceIds.size === this.filteredUndistributedDevices.length;
			} else {
				// 如果不是全选状态，只添加当前页选中的设备ID
				currentPageSelectedIds.forEach(id => {
					this.allSelectedDeviceIds.add(id);
				});
			}
			
			// 更新selectedDevices为所有选中的设备对象数组
			this.selectedDevices = this.filteredUndistributedDevices.filter(device => 
				this.allSelectedDeviceIds.has(device.id)
			);
		},
		// 处理单行选择
		handleDeviceSelect(selection, row) {
			const isSelected = selection.some(item => item.id === row.id);
			
			if (isSelected) {
				this.allSelectedDeviceIds.add(row.id);
			} else {
				this.allSelectedDeviceIds.delete(row.id);
				// 如果取消选择了某个设备，取消全选状态
				this.isAllSelected = false;
			}
			
			// 更新selectedDevices
			this.selectedDevices = this.filteredUndistributedDevices.filter(device => 
				this.allSelectedDeviceIds.has(device.id)
			);
		},
		// 处理全选
		handleDeviceSelectAll(selection) {
			if (selection.length > 0) {
				// 全选当前页
				selection.forEach(item => {
					this.allSelectedDeviceIds.add(item.id);
				});
			} else {
				// 取消全选当前页
				this.paginatedDevices.forEach(item => {
					this.allSelectedDeviceIds.delete(item.id);
				});
				this.isAllSelected = false;
			}
			
			// 检查是否全选了所有过滤后的设备
			this.isAllSelected = this.allSelectedDeviceIds.size === this.filteredUndistributedDevices.length;
			
			// 更新selectedDevices
			this.selectedDevices = this.filteredUndistributedDevices.filter(device => 
				this.allSelectedDeviceIds.has(device.id)
			);
		},
		// 搜索设备
		searchDevices() {
			this.pagination.currentPage = 1; // 重置到第一页
			// 搜索时保持当前选中状态
			if (this.selectedDevices.length > 0) {
				// 更新selectedDevices以匹配新的过滤结果
				this.selectedDevices = this.filteredUndistributedDevices.filter(device => 
					this.allSelectedDeviceIds.has(device.id)
				);
				this.$message.info(`当前已选择 ${this.selectedDevices.length} 台设备，搜索不会清除选择`);
			}
		},
		// 清空搜索
		clearSearch() {
			this.undistributedSearch = '';
			this.pagination.currentPage = 1;
		},
		// 分页相关方法 - 用于车锁分配对话框中的分页
		handleAllocationSizeChange(val) {
			this.pagination.pageSize = val;
			this.pagination.currentPage = 1;
			// 重新设置表格选中状态
			this.$nextTick(() => {
				this.setTableSelection();
			});
		},
		handleAllocationCurrentChange(val) {
			this.pagination.currentPage = val;
			// 重新设置表格选中状态
			this.$nextTick(() => {
				this.setTableSelection();
			});
		},
		// 设置表格选中状态
		setTableSelection() {
			if (!this.$refs.deviceTable) return;
			
			this.$refs.deviceTable.clearSelection();
			this.paginatedDevices.forEach(row => {
				if (this.allSelectedDeviceIds.has(row.id)) {
					this.$refs.deviceTable.toggleRowSelection(row, true);
				}
			});
		},
		revocationAllocation(id, qrNumber) {
			this.$confirm("确认撤销分配 " + qrNumber + " 吗？", {
				title: "提示",
				type: 'warning',
			}).then(resc => {
				this.$http.get('/device/manager/revocationAllocation/' + id).then((res) => {
					if (res.data.code != 200) return this.$message.error(res.data.msg);
					this.reGetlockDeviceList();
					this.$message.success(res.data.msg);
				})
			})
		},
		// 处理下拉菜单命令
		handleCommand(command) {
			switch (command.action) {
				case 'unlock':
					this.showUnlockDialog(command.id, command.imei);
					break;
				case 'lock':
					this.showLockDialog(command.id, command.imei);
					break;
				case 'switchIp':
					this.showSwitchIpDialog(command.id, command.imei);
					break;
				case 'locate':
				this.locateDevice(command.id, command.imei);
				break;
			case 'findVehicle':
				this.findVehicle(command.id, command.imei);
				break;
			}
		},
		// 表格选择变化处理
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 显示开锁指令对话框
		showUnlockDialog(id, imei) {
			this.unlockForm = {
				id: id,
				imei: imei,
				music: 1,
				channel: 1
			};
			this.unlockDialogVisible = true;
		},
		// 显示关锁指令对话框
		showLockDialog(id, imei) {
			this.lockForm = {
				id: id,
				imei: imei,
				mode: 1, // 1表示STAND标准模式
				music: 1
			};
			this.lockDialogVisible = true;
		},
		// 显示切换IP指令对话框
		showSwitchIpDialog(id, imei) {
			this.switchIpForm = {
				id: id,
				imei: imei,
				ip: '',
				port: 6008,
				type: 0
			};
			this.switchIpDialogVisible = true;
		},
		// 发送开锁指令
		sendUnlockCommand() {
			const params = new URLSearchParams();
			params.append('id', this.unlockForm.id);
			params.append('music', this.unlockForm.music);
			params.append('channel', this.unlockForm.channel);

			this.$http.get('/device/manager/info/lowerHireUnlock?' + params.toString()).then((res) => {
				if (res.data.code != 200) {
					return this.$message.error(res.data.msg);
				}
				this.unlockDialogVisible = false;
				this.$message.success('开锁指令下发成功');
			}).catch((error) => {
				this.$message.error('开锁指令下发失败: ' + error.message);
			});
		},
		// 发送关锁指令
		sendLockCommand() {
			const params = new URLSearchParams();
			params.append('id', this.lockForm.id);
			params.append('mode', this.lockForm.mode);
			params.append('music', this.lockForm.music);

			this.$http.get('/device/manager/info/lowerHireLock?' + params.toString()).then((res) => {
				if (res.data.code != 200) {
					return this.$message.error(res.data.msg);
				}
				this.lockDialogVisible = false;
				this.$message.success('关锁指令下发成功');
			}).catch((error) => {
				this.$message.error('关锁指令下发失败: ' + error.message);
			});
		},
		// 发送切换IP指令
		sendSwitchIpCommand() {
			if (!this.switchIpForm.ip) {
				return this.$message.error('请输入IP地址或域名');
			}
			const params = new URLSearchParams();
			params.append('id', this.switchIpForm.id);
			params.append('ip', this.switchIpForm.ip);
			params.append('port', this.switchIpForm.port);
			params.append('type', this.switchIpForm.type);

			this.$http.get('/device/manager/info/lowerHireSwitchIp?' + params.toString()).then((res) => {
				if (res.data.code != 200) {
					return this.$message.error(res.data.msg);
				}
				this.switchIpDialogVisible = false;
				this.$message.success('切换IP指令下发成功');
			}).catch((error) => {
				this.$message.error('切换IP指令下发失败: ' + error.message);
			});
		},
		// 处理表格选择变化
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		// 批量删除
		batchDelete() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要删除的设备');
				return;
			}

			const deviceNames = this.multipleSelection.map(item => item.qrNumber).join(', ');
			this.$confirm(`确认删除以下设备：${deviceNames}`, {
				title: "批量删除确认",
				type: 'warning',
			}).then(() => {
				const promises = [];
				const deviceIds = this.multipleSelection.map(item => item.id);

				deviceIds.forEach(id => {
					promises.push(this.$http.get('/device/manager/deleteLockDeviceById/' + id));
				});

				Promise.all(promises)
					.then(results => {
						const successCount = results.filter(res => res.data.code === 200).length;
						const failCount = results.length - successCount;

						if (failCount === 0) {
							this.$message.success(`批量删除全部成功，共${successCount}台设备`);
						} else {
							this.$message.warning(`批量删除部分成功，成功${successCount}台，失败${failCount}台`);
						}

						this.reGetlockDeviceList();
					})
					.catch(error => {
						console.error('批量删除失败:', error);
						this.$message.error('批量删除失败');
					});
			}).catch(() => {
				this.$message.info('已取消批量删除');
			});
		},
		// 批量开锁
		batchUnlock() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要开锁的设备');
				return;
			}
			this.batchUnlockDialogVisible = true;
		},
		// 批量关锁
		batchLock() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要关锁的设备');
				return;
			}
			this.batchLockDialogVisible = true;
		},
		// 批量切换IP
		batchSwitchIp() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要切换IP的设备');
				return;
			}
			this.batchSwitchIpDialogVisible = true;
		},
		// 批量上架
		batchOnline() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要上架的设备');
				return;
			}
			this.$confirm('确定要批量上架选中的设备吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const ids = this.multipleSelection.map(item => item.id);
				this.$http.post('/device/manager/batchOnline', ids).then((res) => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '批量上架失败');
						return;
					}
					this.$message.success('批量上架成功');
					this.reGetlockDeviceList();
				}).catch((err) => {
					this.$message.error('批量上架失败');
				});
			}).catch(() => {
				this.$message.info('已取消批量上架');
			});
		},
		// 批量下架
		batchOffline() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要下架的设备');
				return;
			}
			this.$confirm('确定要批量下架选中的设备吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const ids = this.multipleSelection.map(item => item.id);
				this.$http.post('/device/manager/batchOffline', ids).then((res) => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '批量下架失败');
						return;
					}
					this.$message.success('批量下架成功');
					this.reGetlockDeviceList();
				}).catch((err) => {
					this.$message.error('批量下架失败');
				});
			}).catch(() => {
				this.$message.info('已取消批量下架');
			});
		},
		// 单个设备上架/下架状态切换
		handleValidChange(row) {
			const statusText = row.isValid === 1 ? '上架' : '下架';
			this.$http.post('/device/manager/' + (row.isValid === 1 ? 'batchOnline' : 'batchOffline'), [row.id]).then((res) => {
				if (res.data.code !== 200) {
					this.$message.error(res.data.msg || statusText + '失败');
					row.isValid = row.isValid === 1 ? 0 : 1;
					return;
				}
				this.$message.success(statusText + '成功');
			}).catch((err) => {
				this.$message.error(statusText + '失败');
				row.isValid = row.isValid === 1 ? 0 : 1;
			});
		},
		// 发送批量开锁指令
		sendBatchUnlockCommand() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要开锁的设备');
				return;
			}

			const promises = [];
			const deviceIds = this.multipleSelection.map(item => item.id);

			deviceIds.forEach(id => {
				const params = new URLSearchParams();
				params.append('id', id);
				params.append('music', this.batchUnlockForm.music);
				params.append('channel', this.batchUnlockForm.channel);

				promises.push(this.$http.get('/device/manager/info/lowerHireUnlock', { params }));
			});

			Promise.all(promises)
				.then(results => {
					const successCount = results.filter(res => res.data.code === 200).length;
					const failCount = results.length - successCount;

					if (failCount === 0) {
						this.$message.success(`批量开锁指令全部发送成功，共${successCount}台设备`);
					} else {
						this.$message.warning(`批量开锁指令部分发送成功，成功${successCount}台，失败${failCount}台`);
					}

					this.batchUnlockDialogVisible = false;
				})
				.catch(error => {
					console.error('发送批量开锁指令失败:', error);
					this.$message.error('发送批量开锁指令失败');
				});
		},
		// 发送批量关锁指令
		sendBatchLockCommand() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要关锁的设备');
				return;
			}

			const promises = [];
			const deviceIds = this.multipleSelection.map(item => item.id);

			deviceIds.forEach(id => {
				const params = new URLSearchParams();
				params.append('id', id);
				params.append('mode', this.batchLockForm.mode);
				params.append('music', this.batchLockForm.music);

				promises.push(this.$http.get('/device/manager/info/lowerHireLock', { params }));
			});

			Promise.all(promises)
				.then(results => {
					const successCount = results.filter(res => res.data.code === 200).length;
					const failCount = results.length - successCount;

					if (failCount === 0) {
						this.$message.success(`批量关锁指令全部发送成功，共${successCount}台设备`);
					} else {
						this.$message.warning(`批量关锁指令部分发送成功，成功${successCount}台，失败${failCount}台`);
					}

					this.batchLockDialogVisible = false;
				})
				.catch(error => {
					console.error('发送批量关锁指令失败:', error);
					this.$message.error('发送批量关锁指令失败');
				});
		},
		// 发送批量切换IP指令
		sendBatchSwitchIpCommand() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要切换IP的设备');
				return;
			}

			if (!this.batchSwitchIpForm.ip || !this.batchSwitchIpForm.port) {
				this.$message.error('IP地址和端口号不能为空');
				return;
			}

			const promises = [];
			const deviceIds = this.multipleSelection.map(item => item.id);

			deviceIds.forEach(id => {
				const params = new URLSearchParams();
				params.append('id', id);
				params.append('ip', this.batchSwitchIpForm.ip);
				params.append('port', this.batchSwitchIpForm.port);
				params.append('type', this.batchSwitchIpForm.type);

				promises.push(this.$http.get('/device/manager/info/lowerHireSwitchIp', { params }));
			});

			Promise.all(promises)
				.then(results => {
					const successCount = results.filter(res => res.data.code === 200).length;
					const failCount = results.length - successCount;

					if (failCount === 0) {
						this.$message.success(`批量切换IP指令全部发送成功，共${successCount}台设备`);
					} else {
						this.$message.warning(`批量切换IP指令部分发送成功，成功${successCount}台，失败${failCount}台`);
					}

					this.batchSwitchIpDialogVisible = false;
				})
				.catch(error => {
					console.error('发送批量切换IP指令失败:', error);
					this.$message.error('发送批量切换IP指令失败');
				});
		},
		// 单个设备找车
		findVehicle(id, imei) {
			this.$confirm(`确认对设备IMEI: ${imei} 下发找车指令吗？`, {
				title: "找车确认",
				type: 'info',
			}).then(() => {
				this.$http.get('/device/manager/info/lowerHireFindVehicle', { params: { id: id } })
					.then(res => {
						if (res.data.code != 200) {
							return this.$message.error(res.data.msg);
						}
						this.$message.success('找车指令下发成功');
					})
					.catch(error => {
						console.error('找车指令下发失败:', error);
						this.$message.error('找车指令下发失败');
					});
			}).catch(() => {
				this.$message.info('已取消找车');
			});
		},
		// 单个设备定位
		locateDevice(id, imei) {
			this.$confirm(`确认定位设备IMEI: ${imei} 吗？`, {
				title: "定位确认",
				type: 'info',
			}).then(() => {
				this.$http.get('/device/manager/info/lowerHireLocationUpdate/' + id + '/' + 300)
					.then(res => {
						if (res.data.code != 200) {
							return this.$message.error(res.data.msg);
						}
						this.$message.success('定位指令下发成功');
					})
					.catch(error => {
						console.error('定位指令下发失败:', error);
						this.$message.error('定位指令下发失败');
					});
			}).catch(() => {
				this.$message.info('已取消定位');
			});
		},
		// 批量定位
		batchLocate() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要定位的设备');
				return;
			}
			this.batchLocateDialogVisible = true;
		},
		// 批量撤销分配
		batchRevokeAllocation() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要撤销分配的设备');
				return;
			}

			// 检查是否有已分配的设备
			const allocatedDevices = this.multipleSelection.filter(item => item.isAllot == 1);
			if (allocatedDevices.length === 0) {
				this.$message.warning('所选设备中没有已分配的设备');
				return;
			}

			this.batchRevokeAllocationDialogVisible = true;
		},
		// 发送批量定位指令
		sendBatchLocateCommand() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要定位的设备');
				return;
			}
			const promises = [];
			const deviceIds = this.multipleSelection.map(item => item.id);
			deviceIds.forEach(id => {
				promises.push(this.$http.get('/device/manager/info/lowerHireLocationUpdate/' + id + '/' + this.batchLocateForm.time));
			});
			Promise.all(promises)
				.then(results => {
					const successCount = results.filter(res => res.data.code === 200).length;
					const failCount = results.length - successCount;

					if (failCount === 0) {
						this.$message.success(`批量定位指令全部发送成功，共${successCount}台设备`);
					} else {
						this.$message.warning(`批量定位指令部分发送成功，成功${successCount}台，失败${failCount}台`);
					}

					this.batchLocateDialogVisible = false;
				})
				.catch(error => {
					console.error('发送批量定位指令失败:', error);
					this.$message.error('发送批量定位指令失败');
				});
		},
		// 发送批量撤销分配命令
		sendBatchRevokeAllocationCommand() {
			const allocatedDevices = this.multipleSelection.filter(item => item.isAllot == 1);

			if (allocatedDevices.length === 0) {
				this.$message.warning('所选设备中没有已分配的设备');
				return;
			}

			this.$confirm(`确认撤销分配以下${allocatedDevices.length}台设备吗？`, '批量撤销分配', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const promises = [];
				const deviceIds = allocatedDevices.map(item => item.id);

				deviceIds.forEach(id => {
					promises.push(this.$http.get('/device/manager/revocationAllocation/' + id));
				});

				Promise.all(promises)
					.then(results => {
						const successCount = results.filter(res => res.data.code === 200).length;
						const failCount = results.length - successCount;

						if (failCount === 0) {
							this.$message.success(`批量撤销分配全部成功，共${successCount}台设备`);
						} else {
							this.$message.warning(`批量撤销分配部分成功，成功${successCount}台，失败${failCount}台`);
						}

						this.batchRevokeAllocationDialogVisible = false;
						this.reGetlockDeviceList();
					})
					.catch(error => {
						console.error('发送批量撤销分配指令失败:', error);
						this.$message.error('发送批量撤销分配指令失败');
					});
			}).catch(() => {
				this.$message.info('已取消批量撤销分配');
			});
		},
		// 批量修改车锁类型
		batchModifyBicycleType() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要修改的设备');
				return;
			}
			this.batchModifyBicycleTypeForm.bicycleType = null;
			this.batchModifyBicycleTypeDialogVisible = true;
		},
		// 批量修改协议类型
		batchModifyProtocolType() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要修改的设备');
				return;
			}
			this.batchModifyProtocolTypeForm.protocolType = null;
			this.batchModifyProtocolTypeDialogVisible = true;
		},
		batchModifyDeviceType() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要修改的设备');
				return;
			}
			this.batchModifyDeviceTypeForm.deviceType = null;
			this.batchModifyDeviceTypeDialogVisible = true;
		},
		// 批量休眠
		batchSleep() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要休眠的设备');
				return;
			}
			this.batchSleepForm.mode = 0;
			this.batchSleepForm.time = 300;
			this.batchSleepDialogVisible = true;
		},
		// 批量设置语音播报
		batchSetVoice() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要设置语音播报的设备');
				return;
			}
			this.batchSetVoiceForm.voiceType = null;
			this.batchSetVoiceForm.voiceContent = '';
			this.batchSetVoiceDialogVisible = true;
		},
		batchModifyCustomVoice() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要修改的设备');
				return;
			}
			this.batchModifyCustomVoiceForm.enableCustomVoice = null;
			this.batchModifyCustomVoiceForm.lockVoiceContent = '';
			this.batchModifyCustomVoiceForm.fenceReturnVoiceContent = '';
			this.batchModifyCustomVoiceDialogVisible = true;
		},
		// 发送批量修改车锁类型命令
		sendBatchModifyBicycleTypeCommand() {
			if (!this.batchModifyBicycleTypeForm.bicycleType) {
				this.$message.warning('请选择车锁类型');
				return;
			}

			const deviceIds = this.multipleSelection.map(item => item.id);
			const params = {
				ids: deviceIds,
				bicycleType: this.batchModifyBicycleTypeForm.bicycleType
			};

			this.$confirm(`确认将选中的 ${deviceIds.length} 台设备的车锁类型修改为${this.batchModifyBicycleTypeForm.bicycleType === 1 ? '自行车' : this.batchModifyBicycleTypeForm.bicycleType === 2 ? '电动车' : '涨闸锁'}吗？`, '批量修改车锁类型', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post('/device/manager/batchUpdateBicycleType', params).then((res) => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '批量修改车锁类型失败');
						return;
					}
					this.$message.success('批量修改车锁类型成功');
					this.batchModifyBicycleTypeDialogVisible = false;
					this.reGetlockDeviceList();
				}).catch((err) => {
					this.$message.error('批量修改车锁类型失败');
				});
			}).catch(() => {
				this.$message.info('已取消批量修改车锁类型');
			});
		},
		// 发送批量修改协议类型命令
		sendBatchModifyProtocolTypeCommand() {
			if (!this.batchModifyProtocolTypeForm.protocolType) {
				this.$message.warning('请选择协议类型');
				return;
			}

			const deviceIds = this.multipleSelection.map(item => item.id);
			const params = {
				ids: deviceIds,
				protocolType: this.batchModifyProtocolTypeForm.protocolType
			};

			const protocolTypeName = this.batchModifyProtocolTypeForm.protocolType === 1 ? '友信智联协议' : '义卫士4G协议';
			this.$confirm(`确认将选中的 ${deviceIds.length} 台设备的协议类型修改为${protocolTypeName}吗？`, '批量修改协议类型', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post('/device/manager/batchUpdateProtocolType', params).then((res) => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '批量修改协议类型失败');
						return;
					}
					this.$message.success('批量修改协议类型成功');
					this.batchModifyProtocolTypeDialogVisible = false;
					this.reGetlockDeviceList();
				}).catch((err) => {
					this.$message.error('批量修改协议类型失败');
				});
			}).catch(() => {
				this.$message.info('已取消批量修改协议类型');
			});
		},
		sendBatchModifyDeviceTypeCommand() {
			if (!this.batchModifyDeviceTypeForm.deviceType) {
				this.$message.warning('请选择车辆类型');
				return;
			}

			const deviceIds = this.multipleSelection.map(item => item.id);
			const params = {
				ids: deviceIds,
				deviceType: this.batchModifyDeviceTypeForm.deviceType
			};

			const deviceTypeName = this.getDeviceTypeName(this.batchModifyDeviceTypeForm.deviceType) || '未知';
			this.$confirm(`确认将选中的 ${deviceIds.length} 台设备的车辆类型修改为${deviceTypeName}吗？`, '批量修改车辆类型', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post('/device/manager/batchUpdateDeviceType', params).then((res) => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '批量修改车辆类型失败');
						return;
					}
					this.$message.success('批量修改车辆类型成功');
					this.batchModifyDeviceTypeDialogVisible = false;
					this.reGetlockDeviceList();
				}).catch((err) => {
					this.$message.error('批量修改车辆类型失败');
				});
			}).catch(() => {
				this.$message.info('已取消批量修改车辆类型');
			});
		},
		sendBatchModifyCustomVoiceCommand() {
			if (this.batchModifyCustomVoiceForm.enableCustomVoice === null) {
				this.$message.warning('请选择是否开启自定义语音播报');
				return;
			}

			const deviceIds = this.multipleSelection.map(item => item.id);
			const params = {
				ids: deviceIds,
				enableCustomVoice: this.batchModifyCustomVoiceForm.enableCustomVoice,
				lockVoiceContent: this.batchModifyCustomVoiceForm.lockVoiceContent,
				fenceReturnVoiceContent: this.batchModifyCustomVoiceForm.fenceReturnVoiceContent
			};

			const voiceStatus = this.batchModifyCustomVoiceForm.enableCustomVoice === 1 ? '开启' : '关闭';
			this.$confirm(`确认将选中的 ${deviceIds.length} 台设备的自定义语音播报设置为${voiceStatus}吗？`, '批量修改自定义语音播报', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post('/device/manager/batchUpdateCustomVoice', params).then((res) => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '批量修改自定义语音播报失败');
						return;
					}
					this.$message.success('批量修改自定义语音播报成功');
					this.batchModifyCustomVoiceDialogVisible = false;
					this.reGetlockDeviceList();
				}).catch((err) => {
					this.$message.error('批量修改自定义语音播报失败');
				});
			}).catch(() => {
				this.$message.info('已取消批量修改自定义语音播报');
			});
		},
		// 发送批量休眠命令
		sendBatchSleepCommand() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要休眠的设备');
				return;
			}

			const deviceIds = this.multipleSelection.map(item => item.id);
			const params = {
				ids: deviceIds,
				mode: this.batchSleepForm.mode,
				time: this.batchSleepForm.time
			};

			const modeNames = ['退出休眠', '24小时深度休眠', '深度休眠(设备主动唤醒后GPS关闭)', 'GPS休眠(GPS关闭)', '深度休眠(每隔1分钟发送定位)', 'GSM休眠模式'];
			const modeName = modeNames[this.batchSleepForm.mode] || '未知模式';
			this.$confirm(`确认将选中的 ${deviceIds.length} 台设备设置为${modeName}吗？`, '批量休眠', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post('/device/manager/batchSleep', params).then((res) => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '批量休眠指令发送失败');
						return;
					}
					this.$message.success('批量休眠指令发送成功');
					this.batchSleepDialogVisible = false;
				}).catch((err) => {
					this.$message.error('批量休眠指令发送失败');
				});
			}).catch(() => {
				this.$message.info('已取消批量休眠');
			});
		},
		// 发送批量设置语音播报命令
		sendBatchSetVoiceCommand() {
			if (!this.batchSetVoiceForm.voiceType) {
				this.$message.warning('请选择语音类型');
				return;
			}
			if (!this.batchSetVoiceForm.voiceContent) {
				this.$message.warning('请输入语音内容');
				return;
			}

			const deviceIds = this.multipleSelection.map(item => item.id);
			const params = {
				ids: deviceIds,
				voiceType: this.batchSetVoiceForm.voiceType,
				voiceContent: this.batchSetVoiceForm.voiceContent
			};

			const voiceTypeNames = ['', '开锁成功语音', '开锁失败语音', '关锁成功语音', '关锁失败语音'];
			const voiceTypeName = voiceTypeNames[this.batchSetVoiceForm.voiceType] || '未知类型';
			this.$confirm(`确认将选中的 ${deviceIds.length} 台设备的${voiceTypeName}设置为"${this.batchSetVoiceForm.voiceContent}"吗？`, '批量设置语音播报', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http.post('/device/manager/batchSetVoice', params).then((res) => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '批量设置语音播报指令发送失败');
						return;
					}
					this.$message.success('批量设置语音播报指令发送成功');
					this.batchSetVoiceDialogVisible = false;
				}).catch((err) => {
					this.$message.error('批量设置语音播报指令发送失败');
				});
			}).catch(() => {
				this.$message.info('已取消批量设置语音播报');
			});
		},
		// 批量升级
		batchUpgrade() {
			if (this.multipleSelection.length === 0) {
				this.$message.warning('请选择要升级的设备');
				return;
			}
			this.$confirm('确定要批量升级选中的设备吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				const ids = this.multipleSelection.map(item => item.id);
				this.$http.post('/device/manager/batchUpgrade', ids).then((res) => {
					if (res.data.code !== 200) {
						this.$message.error(res.data.msg || '批量升级失败');
						return;
					}
					this.$message.success(res.data.msg || '批量升级成功');
				}).catch((err) => {
					this.$message.error('批量升级失败');
				});
			}).catch(() => {
				this.$message.info('已取消批量升级');
			});
		},
		// 处理批量导入车锁按钮点击
		handleImportLockDevices() {
			this.$refs.fileInput.click();
		},
		// 处理文件选择变化
		handleFileChange(event) {
			const file = event.target.files[0];
			if (!file) return;

			// 验证文件类型
			const isExcel = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' ||
				file.type === 'application/vnd.ms-excel';
			if (!isExcel) {
				this.$message.error('只能上传Excel文件!');
				// 清空文件选择
				event.target.value = '';
				return;
			}

			// 验证文件大小
			const isLt10M = file.size / 1024 / 1024 < 10;
			if (!isLt10M) {
				this.$message.error('上传文件大小不能超过 10MB!');
				// 清空文件选择
				event.target.value = '';
				return;
			}

			// 创建FormData对象
			const formData = new FormData();
			formData.append('file', file);

			// 显示上传中提示
			const loading = this.$loading({
				lock: true,
				text: '正在上传文件，请稍候...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});

			// 使用this.$http上传文件
			this.$http.post('/device/manager/importLockDevices', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			}).then(response => {
				loading.close();
				if (response.data.code === 200) {
					this.$message.success(response.data.msg || '文件上传成功');
					// 刷新列表
					this.reGetlockDeviceList();
				} else {
					this.$message.error(response.data.msg || '文件上传失败');
				}
			}).catch(error => {
				loading.close();
				this.$message.error('文件上传失败，请重试');
				console.error('上传错误:', error);
			}).finally(() => {
				// 清空文件选择
				event.target.value = '';
			});
		},
		showTrackDialog(row) {
			this.trackImei = row.imei;
			this.trackPoints = [];
			var today = new Date();
			var yyyy = today.getFullYear();
			var MM = String(today.getMonth() + 1).padStart(2, '0');
			var dd = String(today.getDate()).padStart(2, '0');
			var todayStr = yyyy + MM + dd;
			this.trackDateRange = [todayStr, todayStr];
			this.trackDialogVisible = true;
			this.$nextTick(() => {
				setTimeout(() => {
					this.initTrackMap();
					this.loadTrackData();
				}, 200);
			});
		},
		initTrackMap() {
			if (this.trackMap) {
				try { this.trackMap.destroy(); } catch(e) {}
				this.trackMap = null;
			}
			var container = document.getElementById('track_map_view');
			if (!container || typeof TMap === 'undefined') {
				setTimeout(() => { this.initTrackMap(); }, 200);
				return;
			}
			var center = new TMap.LatLng(32.902652, 117.440006);
			this.trackMap = new TMap.Map(container, {
				center: center,
				zoom: 14
			});
		},
		loadTrackData() {
			if (!this.trackImei) {
				this.$message.warning('设备IMEI为空，无法查询轨迹');
				return;
			}
			var startDate = '';
			var endDate = '';
			if (this.trackDateRange && this.trackDateRange.length === 2) {
				startDate = this.trackDateRange[0];
				endDate = this.trackDateRange[1];
			} else {
				var today = new Date();
				var yyyy = today.getFullYear();
				var MM = String(today.getMonth() + 1).padStart(2, '0');
				var dd = String(today.getDate()).padStart(2, '0');
				startDate = yyyy + MM + dd;
				endDate = startDate;
			}
			this.trackLoading = true;
			this.clearTrackOverlays();
			this.trackPoints = [];
			this.trackPath = [];
			this.trackPointInfos = [];
			this.pauseTrackPlay();
			this.$http.get('/device/track/list', {
				params: { imei: this.trackImei, startDate: startDate, endDate: endDate }
			}).then((res) => {
				this.trackLoading = false;
				if (res.data.code !== 200) {
					this.$message.error(res.data.msg || '查询轨迹失败');
					return;
				}
				var result = res.data.data || {};
				var list = result.list || [];
				if (list.length === 0) {
					this.$message.info('暂无轨迹数据');
					return;
				}
				var points = [];
				for (var i = 0; i < list.length; i++) {
					var item = list[i];
					var timestamp = Math.floor(new Date(item.trackTime).getTime() / 1000);
					points.push(item.latitude + ',' + item.longitude + ',' + timestamp);
				}
				this.trackPoints = points;
				this.drawTrack(points);
			}).catch((err) => {
				this.trackLoading = false;
				console.error('查询轨迹异常, 详细信息:', err);
				var errMsg = err && err.message ? err.message : (err || '未知错误');
				this.$message.error('查询轨迹失败: ' + errMsg);
			});
		},
		drawTrack(points) {
			if (!this.trackMap) return;
			this.clearTrackOverlays();
			var path = [];
			var infos = [];
			var minLat = 90, maxLat = -90, minLng = 180, maxLng = -180;
			for (var i = 0; i < points.length; i++) {
				var parts = points[i].split(',');
				var lat = parseFloat(parts[0]);
				var lng = parseFloat(parts[1]);
				if (!isNaN(lat) && !isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180) {
					var latLng = new TMap.LatLng(lat, lng);
					path.push(latLng);
					infos.push({ position: latLng, timeText: this.formatTrackTime(parseInt(parts[2], 10)) });
					if (lat < minLat) minLat = lat;
					if (lat > maxLat) maxLat = lat;
					if (lng < minLng) minLng = lng;
					if (lng > maxLng) maxLng = lng;
				}
			}
			if (path.length === 0) return;

			this.trackPath = path;
			this.trackPointInfos = infos;
			this.trackCurrentIndex = path.length;

			this.trackPolyline = new TMap.MultiPolyline({
				map: this.trackMap,
				styles: {
					'style_line': new TMap.PolylineStyle({
						color: '#3777FF',
						width: 4
					})
				},
				geometries: [{
					styleId: 'style_line',
					paths: [path]
				}]
			});

			this.trackMarkerLayer = new TMap.MultiMarker({
				map: this.trackMap,
				styles: {
					'startStyle': new TMap.MarkerStyle({
						width: 24,
						height: 24,
						src: require('@/assets/image/markers.png'),
						anchor: { x: 12, y: 24 }
					}),
					'endStyle': new TMap.MarkerStyle({
						width: 24,
						height: 24,
						src: require('@/assets/image/markers.png'),
						anchor: { x: 12, y: 24 }
					})
				},
				geometries: [{
					id: 'start',
					styleId: 'startStyle',
					position: path[0]
				}, {
					id: 'end',
					styleId: 'endStyle',
					position: path[path.length - 1]
				}]
			});

			if (this.trackLabelLayer) {
				try { this.trackLabelLayer.setMap(null); } catch(e) {}
			}
			this.trackLabelLayer = new TMap.MultiLabel({
				map: this.trackMap,
				styles: {
					'startLabel': new TMap.LabelStyle({
						position: 'top',
						offset: { x: 0, y: -35 },
						size: 13,
						color: '#fff',
						backgroundColor: '#52c41a',
						width: 40,
						height: 20,
						borderColor: '#52c41a',
						borderWidth: 1,
						borderRadius: 4,
						padding: 4,
						enableCollision: false
					}),
					'endLabel': new TMap.LabelStyle({
						position: 'top',
						offset: { x: 0, y: -35 },
						size: 13,
						color: '#fff',
						backgroundColor: '#ff4d4f',
						width: 40,
						height: 20,
						borderColor: '#ff4d4f',
						borderWidth: 1,
						borderRadius: 4,
						padding: 4,
						enableCollision: false
					})
				},
				geometries: [{
					id: 'startLabel',
					styleId: 'startLabel',
					position: path[0],
					content: '起点'
				}, {
					id: 'endLabel',
					styleId: 'endLabel',
					position: path[path.length - 1],
					content: '终点'
				}]
			});

			this.trackMap.fitBounds(
				new TMap.LatLngBounds(
					new TMap.LatLng(minLat - 0.002, minLng - 0.002),
					new TMap.LatLng(maxLat + 0.002, maxLng + 0.002)
				),
				{ padding: 50 }
			);

			try {
				this.drawTrackDots();
			} catch(e) {
				// 圆点/时间气泡异常不影响轨迹主流程, 仅记录日志
				console.error('绘制轨迹节点圆点异常, 详细信息:', e);
			}
		},
		// 生成轨迹节点圆点图片(白色描边+蓝色圆心)
		makeTrackDotImage() {
			var canvas = document.createElement('canvas');
			canvas.width = 20;
			canvas.height = 20;
			var ctx = canvas.getContext('2d');
			ctx.beginPath();
			ctx.arc(10, 10, 9, 0, Math.PI * 2);
			ctx.fillStyle = '#FFFFFF';
			ctx.fill();
			ctx.lineWidth = 2;
			ctx.strokeStyle = '#3777FF';
			ctx.stroke();
			ctx.beginPath();
			ctx.arc(10, 10, 5, 0, Math.PI * 2);
			ctx.fillStyle = '#3777FF';
			ctx.fill();
			return canvas.toDataURL('image/png');
		},
		// 时间戳(秒)格式化为 yyyy-MM-dd HH:mm:ss
		formatTrackTime(ts) {
			if (!ts || isNaN(ts)) return '';
			var d = new Date(ts * 1000);
			var p = function(n) { return String(n).padStart(2, '0'); };
			return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate()) + ' ' + p(d.getHours()) + ':' + p(d.getMinutes()) + ':' + p(d.getSeconds());
		},
		// 绘制全部轨迹节点圆点,鼠标悬停/点击显示该点时间
		drawTrackDots() {
			if (!this.trackMap || !this.trackPointInfos || this.trackPointInfos.length === 0) return;
			if (this.trackDotLayer) {
				try { this.trackDotLayer.setMap(null); } catch(e) {}
				this.trackDotLayer = null;
			}
			var geometries = [];
			for (var i = 0; i < this.trackPointInfos.length; i++) {
				geometries.push({
					id: 'dot_' + i,
					styleId: 'dotStyle',
					position: this.trackPointInfos[i].position
				});
			}
			this.trackDotLayer = new TMap.MultiMarker({
				map: this.trackMap,
				styles: {
					'dotStyle': new TMap.MarkerStyle({
						width: 16,
						height: 16,
						src: this.makeTrackDotImage(),
						anchor: { x: 8, y: 8 }
					})
				},
				geometries: geometries
			});
			if (!this.trackInfoWindow) {
				if (typeof TMap.InfoWindow !== 'function') {
					console.error('当前腾讯地图GL版本不支持TMap.InfoWindow, 节点时间气泡不可用');
					return;
				}
				this.trackInfoWindow = new TMap.InfoWindow({
					map: this.trackMap,
					position: this.trackPointInfos[0].position,
					offset: { x: 0, y: -10 },
					content: ''
				});
				this.trackInfoWindow.close();
			}
			var that = this;
			this.trackDotLayer.on('mouseover', function(evt) {
				that.showTrackPointTip(evt);
			});
			this.trackDotLayer.on('mouseout', function() {
				that.hideTrackPointTip();
			});
			this.trackDotLayer.on('click', function(evt) {
				that.showTrackPointTip(evt);
			});
		},
		// 显示某个轨迹节点的时间气泡
		showTrackPointTip(evt) {
			if (!this.trackInfoWindow || !evt || !evt.geometry) return;
			var idx = parseInt(String(evt.geometry.id).replace('dot_', ''), 10);
			if (isNaN(idx) || !this.trackPointInfos[idx]) return;
			var info = this.trackPointInfos[idx];
			if (!info.timeText) return;
			this.trackInfoWindow.setPosition(info.position);
			this.trackInfoWindow.setContent('<div style="padding:4px 8px;font-size:13px;color:#333;white-space:nowrap;">' + info.timeText + '</div>');
			this.trackInfoWindow.open();
		},
		hideTrackPointTip() {
			if (this.trackInfoWindow) {
				try { this.trackInfoWindow.close(); } catch(e) {}
			}
		},
		clearTrackOverlays() {
			this.hideTrackPointTip();
			if (this.trackDotLayer) {
				try { this.trackDotLayer.setMap(null); } catch(e) {}
				this.trackDotLayer = null;
			}
			if (this.trackPolyline) {
				try { this.trackPolyline.setMap(null); } catch(e) {}
				this.trackPolyline = null;
			}
			if (this.trackMarkerLayer) {
				try { this.trackMarkerLayer.setMap(null); } catch(e) {}
				this.trackMarkerLayer = null;
			}
			if (this.trackLabelLayer) {
				try { this.trackLabelLayer.setMap(null); } catch(e) {}
				this.trackLabelLayer = null;
			}
			if (this.trackMoveMarker) {
				try { this.trackMoveMarker.setMap(null); } catch(e) {}
				this.trackMoveMarker = null;
			}
		},
		toggleTrackPlay() {
			if (this.trackPlaying) {
				this.pauseTrackPlay();
			} else {
				this.startTrackPlay();
			}
		},
		startTrackPlay() {
			if (this.trackPath.length < 2) return;
			this.pauseTrackPlay();
			this.trackCurrentIndex = 1;
			this.trackPlaying = true;

			this.clearTrackOverlays();
			// 回放时保留节点圆点,便于随时查看每个点的时间
			this.drawTrackDots();

			this.trackMoveMarker = new TMap.MultiMarker({
				map: this.trackMap,
				styles: {
					'moveStyle': new TMap.MarkerStyle({
						width: 20,
						height: 20,
						src: require('@/assets/image/markers.png'),
						anchor: { x: 10, y: 20 }
					})
				},
				geometries: [{
					id: 'moveMarker',
					styleId: 'moveStyle',
					position: this.trackPath[0]
				}]
			});

			this.trackPolyline = new TMap.MultiPolyline({
				map: this.trackMap,
				styles: {
					'style_line': new TMap.PolylineStyle({
						color: '#3777FF',
						width: 4
					})
				},
				geometries: [{
					id: 'trackLine',
					styleId: 'style_line',
					paths: [this.trackPath.slice(0, 2)]
				}]
			});

			this.playNextPoint();
		},
		playNextPoint() {
			if (!this.trackPlaying) return;
			if (this.trackCurrentIndex >= this.trackPath.length) {
				this.trackPlaying = false;
				if (this.trackMoveMarker) {
					try { this.trackMoveMarker.setMap(null); } catch(e) {}
					this.trackMoveMarker = null;
				}
				this.trackPolyline.updateGeometries([{
					id: 'trackLine',
					styleId: 'style_line',
					paths: [this.trackPath]
				}]);
				this.trackMarkerLayer = new TMap.MultiMarker({
					map: this.trackMap,
					styles: {
						'startStyle': new TMap.MarkerStyle({
							width: 24,
							height: 24,
							src: require('@/assets/image/markers.png'),
							anchor: { x: 12, y: 24 }
						}),
						'endStyle': new TMap.MarkerStyle({
							width: 24,
							height: 24,
							src: require('@/assets/image/markers.png'),
							anchor: { x: 12, y: 24 }
						})
					},
					geometries: [{
						id: 'start',
						styleId: 'startStyle',
						position: this.trackPath[0]
					}, {
						id: 'end',
						styleId: 'endStyle',
						position: this.trackPath[this.trackPath.length - 1]
					}]
				});

				if (this.trackLabelLayer) {
					try { this.trackLabelLayer.setMap(null); } catch(e) {}
				}
				this.trackLabelLayer = new TMap.MultiLabel({
					map: this.trackMap,
					styles: {
						'startLabel': new TMap.LabelStyle({
							position: 'top',
							offset: { x: 0, y: -35 },
							size: 13,
							color: '#fff',
							backgroundColor: '#52c41a',
							width: 40,
							height: 20,
							borderColor: '#52c41a',
							borderWidth: 1,
							borderRadius: 4,
							padding: 4,
							enableCollision: false
						}),
						'endLabel': new TMap.LabelStyle({
							position: 'top',
							offset: { x: 0, y: -35 },
							size: 13,
							color: '#fff',
							backgroundColor: '#ff4d4f',
							width: 40,
							height: 20,
							borderColor: '#ff4d4f',
							borderWidth: 1,
							borderRadius: 4,
							padding: 4,
							enableCollision: false
						})
					},
					geometries: [{
						id: 'startLabel',
						styleId: 'startLabel',
						position: this.trackPath[0],
						content: '起点'
					}, {
						id: 'endLabel',
						styleId: 'endLabel',
						position: this.trackPath[this.trackPath.length - 1],
						content: '终点'
					}]
				});
				return;
			}

			var from = this.trackPath[this.trackCurrentIndex - 1];
			var to = this.trackPath[this.trackCurrentIndex];
			var INTERP_STEPS = 6;
			var step = 0;
			var that = this;

			function animateStep() {
				if (!that.trackPlaying) return;
				if (step >= INTERP_STEPS) {
					that.trackCurrentIndex++;
					that.playNextPoint();
					return;
				}

				var t = (step + 1) / INTERP_STEPS;
				var lat = from.lat + (to.lat - from.lat) * t;
				var lng = from.lng + (to.lng - from.lng) * t;
				var interpPos = new TMap.LatLng(lat, lng);

				var drawnEnd = step === INTERP_STEPS - 1 ? that.trackCurrentIndex + 1 : that.trackCurrentIndex;
				var drawnPath = that.trackPath.slice(0, drawnEnd);
				if (step < INTERP_STEPS - 1) {
					drawnPath.push(interpPos);
				}
				that.trackPolyline.updateGeometries([{
					id: 'trackLine',
					styleId: 'style_line',
					paths: [drawnPath]
				}]);

				if (that.trackMoveMarker) {
					that.trackMoveMarker.updateGeometries([{
						id: 'moveMarker',
						styleId: 'moveStyle',
						position: interpPos
					}]);
				}

				step++;
				var baseInterval = Math.max(30, 500 / that.trackSpeed);
				that.trackTimer = setTimeout(animateStep, baseInterval / INTERP_STEPS);
			}

			animateStep();
		},
		pauseTrackPlay() {
			this.trackPlaying = false;
			if (this.trackTimer) {
				clearTimeout(this.trackTimer);
				this.trackTimer = null;
			}
		},
		resetTrackPlay() {
			this.pauseTrackPlay();
			this.trackCurrentIndex = 0;
			if (this.trackMoveMarker) {
				try { this.trackMoveMarker.setMap(null); } catch(e) {}
				this.trackMoveMarker = null;
			}
			this.drawTrack(this.trackPoints);
		},
		closeTrackDialog() {
			this.pauseTrackPlay();
			if (this.trackMap) {
				try { this.trackMap.destroy(); } catch(e) {}
				this.trackMap = null;
			}
			this.trackPolyline = null;
			this.trackMarkerLayer = null;
			this.trackMoveMarker = null;
			this.trackDotLayer = null;
			this.trackInfoWindow = null;
			this.trackPoints = [];
			this.trackPath = [];
			this.trackPointInfos = [];
			this.trackCurrentIndex = 0;
			this.trackPlaying = false;
			this.trackDateRange = null;
		},
	},
}
</script>

<style scoped>
.lock-device-container {
  display: flex;
  flex-direction: column;
}

.box-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: visible;
}

.search-area {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
  padding: 15px 0;
  border-bottom: 1px solid #EBEEF5;
}

.table-container {
  flex: 1;
  overflow-y: auto;
  padding: 15px 0;
}

.pagination-container {
  padding: 15px 0;
  text-align: center;
  border-top: 1px solid #EBEEF5;
  background-color: #fff;
  position: sticky;
  bottom: 0;
  z-index: 10;
}
.track-dialog-content {
  display: flex;
  flex-direction: column;
}
.track-search-bar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.track-info {
  margin-left: 15px;
  color: #909399;
  font-size: 13px;
}
.track-speed-label {
  margin-left: 10px;
  color: #606266;
  font-size: 13px;
  white-space: nowrap;
}
.track-progress {
  color: #909399;
  font-size: 13px;
  white-space: nowrap;
}
.track-map-container {
  width: 100%;
  height: 500px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}
</style>